'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnmountClosed = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _createReactClass = require('create-react-class');

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ReactComponentWithPureRenderMixin = require('react/lib/ReactComponentWithPureRenderMixin');

var _Collapse = require('./Collapse');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var UnmountClosed = (0, _createReactClass2.default)({
  propTypes: {
    isOpened: _propTypes2.default.bool.isRequired,
    onRest: _propTypes2.default.func
  },

  getInitialState: function getInitialState() {
    return {
      shouldUnmount: !this.props.isOpened,
      forceInitialAnimation: !this.props.isOpened
    };
  },
  componentWillReceiveProps: function componentWillReceiveProps(_ref) {
    var isOpened = _ref.isOpened;

    if (!this.props.isOpened && isOpened) {
      this.setState({
        forceInitialAnimation: true,
        shouldUnmount: false
      });
    }
  },


  shouldComponentUpdate: _ReactComponentWithPureRenderMixin.shouldComponentUpdate,

  onRest: function onRest() {
    var _props = this.props,
        isOpened = _props.isOpened,
        onRest = _props.onRest;


    if (!isOpened) {
      this.setState({ shouldUnmount: true });
    }
    if (onRest) {
      onRest.apply(undefined, arguments);
    }
  },
  render: function render() {
    var _props2 = this.props,
        isOpened = _props2.isOpened,
        _onRest = _props2.onRest,
        props = _objectWithoutProperties(_props2, ['isOpened', 'onRest']);

    var _state = this.state,
        forceInitialAnimation = _state.forceInitialAnimation,
        shouldUnmount = _state.shouldUnmount;


    return shouldUnmount ? null : _react2.default.createElement(_Collapse.Collapse, _extends({
      forceInitialAnimation: forceInitialAnimation,
      isOpened: isOpened,
      onRest: this.onRest
    }, props));
  }
});
exports.UnmountClosed = UnmountClosed;
//# sourceMappingURL=UnmountClosed.js.map


//////////////////
// WEBPACK FOOTER
// ./~/react-collapse/lib/UnmountClosed.js
// module id = 535
// module chunks = 0